import React from 'react';
import Reduce from '../../../images/reduce.png';
import { usePortContext } from '../../../service/MessageChannelContext';

const BlurAreaWithReduce = () => {
  const {
    events: { emitLoginEvent },
  } = usePortContext();

  return (
    <div>
      <div className="blurAreaContent">
        <div className="container">
          <div className="row">
            <div className="com-md-12">
              <h2 className="text-center"> How to improve skin texture </h2>
              <div className="blurBox">
                <img src={Reduce} className="img-fluid mb-5 d-block m-auto" />
                <div className="d-flex align-self-center mb-5">
                  <div>
                    <span className="badge-default me-5">1</span>
                  </div>

                  <p className="normal-default-text mb-0 mt-2">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </div>

                <div className="d-flex align-self-center mb-5">
                  <div>
                    <span className="badge-default me-5">2</span>
                  </div>

                  <p className="normal-default-text mb-0 mt-2">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </div>

                <div className="d-flex align-self-center mb-5">
                  <div>
                    <span className="badge-default me-5">3</span>
                  </div>

                  <p className="normal-default-text mb-0 mt-2">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </div>
              </div>

              <button onClick={emitLoginEvent} className="btn btn-primary btn-on-box-position">
                {' '}
                Login or Register{' '}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlurAreaWithReduce;
